import './components.css';
import { Status, WorkflowResult } from '../state/types';
import { Cell } from './Cell';

export type Props = WorkflowResult;

export function WorkflowCell(props: Props) {
  return <Cell rowspan={1}>
    <a href={props.url} target="_blank" class={`result ${props.status}`} title={props.status}>
      {props.ear && <div class={`ear ${props.ear}`}></div>}
    </a>
  </Cell>;
}
